module.exports = __webpack_public_path__ + "img/panda_express.8d161007.svg";